// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__GTJIS","noInteraction":"EventWrapper_noInteraction__4vTg5","pointerPassthrough":"EventWrapper_pointerPassthrough__3CNax"};